module.exports = __webpack_public_path__ + "static/media/LT.745d1b79.wav";